module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_0@3x.869fd863.png";